var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTripIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#989898"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 22H13.0882C12.6827 22 12.2811 21.9224 11.9064 21.7716C11.5317 21.6209 11.1913 21.3999 10.9045 21.1213C10.6178 20.8427 10.3903 20.512 10.2351 20.1481C10.0799 19.7841 10 19.394 10 19C10 18.606 10.0799 18.2159 10.2351 17.852C10.3903 17.488 10.6178 17.1573 10.9045 16.8787C11.1913 16.6001 11.5317 16.3791 11.9064 16.2284C12.2811 16.0776 12.6827 16 13.0882 16H21.0294C21.8485 16 22.634 15.6839 23.2131 15.1213C23.7923 14.5587 24.1176 13.7956 24.1176 13C24.1176 12.2044 23.7923 11.4413 23.2131 10.8787C22.634 10.3161 21.8485 10 21.0294 10L10.4412 10M25 22L21.9118 25M25 22L21.9118 19",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTripIcon);
export default __webpack_public_path__ + "static/media/trip-icon.846dcbe63950de5832302e880158c575.svg";
export { ForwardRef as ReactComponent };